// extracted by mini-css-extract-plugin
export default {"container":"page-in-developing_container__8ei+F","message":"page-in-developing_message__bLcUL"};